import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import RoleHelper from 'helpers/role'
import ProfileHelper from 'helpers/profile'
import ActionHelper from 'helpers/action'
import decodeJWT from 'helpers/decodeJWT'
import { RESET_STORE } from 'constants/index'
import { PROFILE_MNA_FILTERS } from 'constants/mnaFilters'
import { createMyJobDataViewFilters } from 'helpers/myJobs'
import {
  FILTER_TYPE_CREATED_BY,
  FILTER_TYPE_DATE_CREATED_FROM,
  FILTER_TYPE_DATE_CREATED_TO,
  FILTER_TYPE_DATE_UPDATED_FROM,
  FILTER_TYPE_DATE_UPDATED_TO,
  FILTER_TYPE_MODIFIED_BY,
  FILTER_TYPE_STATUS,
} from 'constants/lookupTables'

// constants
export const FETCH_PROFILE = 'profile/FETCH_PROFILE'
export const FETCH_PROFILE_SUCCESS = `${FETCH_PROFILE}_SUCCESS`
export const FETCH_PROFILE_FAILURE = `${FETCH_PROFILE}_FAILURE`
export const UPDATE_PROFILE = 'profile/UPDATE_PROFILE'
export const UPDATE_NOTIFICATION_SETTINGS =
  'profile/UPDATE_NOTIFICATION_SETTINGS'
export const UPDATE_PROFILE_SUCCESS = 'profile/UPDATE_PROFILE_SUCCESS'
export const SET_PROFILE_MNA_FILTERS = 'profile/SET_PROFILE_MNA_FILTERS'
export const UPDATE_PROFILE_MNA_FILTERS = 'profile/UPDATE_PROFILE_MNA_FILTERS'
export const UPDATE_PROFILE_LOGBOOK_FILTERS =
  'profile/UPDATE_PROFILE_LOGBOOK_FILTERS'
export const UPDATE_PROFILE_LOGBOOK_FILTERS_SUCCESS =
  'profile/UPDATE_PROFILE_LOGBOOK_FILTERS_SUCCESS'
export const UPDATE_PROFILE_SITE_SUCCESS = 'profile/UPDATE_PROFILE_SITE_SUCCESS'
export const UPDATE_PHOTO = 'profile/UPDATE_PHOTO'
export const UPDATE_PHOTO_SUCCESS = 'profile/UPDATE_PHOTO_SUCCESS'
export const UPDATE_PASSWORD = 'profile/UPDATE_PASSWORD'
export const UPDATE_USER_LAST_APPLICATION_URL =
  'profile/UPDATE_USER_LAST_APPLICATION_URL'
export const UPDATE_USER_LAST_APPLICATION_URL_SUCCESS =
  'profile/UPDATE_USER_LAST_APPLICATION_URL_SUCCESS'
export const UPDATE_DEEP_LINK = 'profile/UPDATE_DEEP_LINK'
export const [UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILURE] = [
  `${UPDATE_PASSWORD}_SUCCESS`,
  `${UPDATE_PASSWORD}_FAILURE`,
]
export const SET_SITE = 'SET_SITE'
export const SET_JWT_DATA = 'profile/SET_JWT_DATA'
export const SET_LICENSEE_CONTEXT = 'profile/SET_LICENSEE_CONTEXT'
export const SET_SITE_CONTEXT = 'profile/SET_SITE_CONTEXT'
export const REFRESH_TOKEN = 'profile/REFRESH_TOKEN'
export const SET_MY_JOBS_SITE_FILTER = 'profile/SET_MY_JOBS_SITE_FILTER'
export const SET_MY_JOBS_STATUS_FILTER = 'profile/SET_MY_JOBS_STATUS_FILTER'
export const SAVE_MY_JOBS_FILTERS = 'profile/SAVE_MY_JOBS_FILTERS'
export const SAVE_JOBS_SORTING = 'profile/SAVE_JOBS_SORTING'
export const SET_MY_JOBS_DATA_VIEWER_FILTERS =
  'profile/SET_MY_JOBS_DATA_VIEWER_FILTERS'
export const SAVE_MY_JOBS_DATA_VIEWER_FILTERS =
  'profile/SAVE_MY_JOBS_DATA_VIEWER_FILTERS'
export const SAVE_SIGNATURE = 'profile/SAVE_SIGNATURE'
export const DELETE_SIGNATURE = 'profile/DELETE_SIGNATURE'
export const SET_CURRENT_APP_NAME = 'profile/SET_CURRENT_APP_NAME'
export const SIGNATURE_IS_SAVING = 'profile/SIGNATURE_IS_SAVING'
export const PROFILE_IS_FETCHING = 'profile/PROFILE_IS_FETCHING'
export const SAVE_MANAGEMENT_UI_FILTERS =
  'managementUI/SAVE_MANAGEMENT_UI_FILTERS'
export const SAVE_MANAGEMENT_UI_FILTERS_SUCCESS =
  'managementUI/SAVE_MANAGEMENT_UI_FILTERS_SUCCESS'
export const SAVE_LOOKUP_TABLES_FILTERS =
  'managementUI/SAVE_LOOKUP_TABLES_FILTERS'
export const SAVE_LOOKUP_TABLES_FILTERS_SUCCESS =
  'managementUI/SAVE_LOOKUP_TABLES_FILTERS_SUCCESS'

// actions
export const refreshToken = ActionHelper.createActionObj(REFRESH_TOKEN)
export const userLogout = ActionHelper.createActionObj(RESET_STORE)
export const fetchProfile = ActionHelper.createActionObj(FETCH_PROFILE)
export const updateProfile = ActionHelper.createActionObj(UPDATE_PROFILE)
export const updateNotificationSettings = ActionHelper.createActionObj(
  UPDATE_NOTIFICATION_SETTINGS,
)
export const setProfileMnaFilters = ActionHelper.createActionObj(
  SET_PROFILE_MNA_FILTERS,
)
export const updateProfileMnaFilters = ActionHelper.createActionObj(
  UPDATE_PROFILE_MNA_FILTERS,
)
export const updateProfileLogbookFilters = ActionHelper.createActionObj(
  UPDATE_PROFILE_LOGBOOK_FILTERS,
)
export const updatePhoto = ActionHelper.createActionObj(UPDATE_PHOTO)
export const updatePassword = ActionHelper.createActionObj(UPDATE_PASSWORD)
export const updateUserLastApplicationUrl = ActionHelper.createActionObj(
  UPDATE_USER_LAST_APPLICATION_URL,
)
export const setJWTData = ActionHelper.createActionObj(SET_JWT_DATA)
export const setLicenseeContext = ActionHelper.createActionObj(
  SET_LICENSEE_CONTEXT,
)
export const setSiteContext = ActionHelper.createActionObj(SET_SITE_CONTEXT)
export const setMyJobsSiteFilter = ActionHelper.createActionObj(
  SET_MY_JOBS_SITE_FILTER,
)
export const setMyJobsStatusFilter = ActionHelper.createActionObj(
  SET_MY_JOBS_STATUS_FILTER,
)
export const saveMyJobsFilters = ActionHelper.createActionObj(
  SAVE_MY_JOBS_FILTERS,
)
export const saveJobsSorting = ActionHelper.createActionObj(SAVE_JOBS_SORTING)
export const setCurrentAppName = ActionHelper.createActionObj(
  SET_CURRENT_APP_NAME,
)
export const setMyJobsDataViewerFilter = ActionHelper.createActionObj(
  SET_MY_JOBS_DATA_VIEWER_FILTERS,
)
export const saveMyJobsDataViewerFilters = ActionHelper.createActionObj(
  SAVE_MY_JOBS_DATA_VIEWER_FILTERS,
)
export const saveManagementUIFilters = ActionHelper.createActionObj(
  SAVE_MANAGEMENT_UI_FILTERS,
)
export const saveLookupTablesFilters = ActionHelper.createActionObj(
  SAVE_LOOKUP_TABLES_FILTERS,
)
export const updateDeepLink = ActionHelper.createActionObj(UPDATE_DEEP_LINK)
export const saveSignature = ActionHelper.createActionObj(SAVE_SIGNATURE)
export const deleteSignature = ActionHelper.createActionObj(DELETE_SIGNATURE)

// store
const initialState = () =>
  fromJS({
    loading: false,
    isAuth: false,
    jwtData: null,
    siteId: 0,
    roleLevel: 0,
    licenseeId: 0,
    licenseeName: '',
    currentAppName: '',
    profile: {
      id: 0,
      email: '',
      name: '',
      locale: localStorage.getItem('lang'),
      licensee: {
        id: 0,
        name: '',
        dateCreated: '',
        dateUpdated: '',
      },
      site: {
        id: 0,
        name: '',
      },
      applications: List([]),
      pictureUrl: '',
      roles: [''],
      enabled: true,
      dateCreated: '',
      dateUpdated: '',
      lastApplicationUrl: '',
      deepLink: '',
      currentApp: {},
      featureFlags: [],
      canSeeDeletedJobs: false,
      canRecoverDeletedJobs: false,
    },
    jobsManagementFilters: {
      overdue: null,
      data_columns: [],
      site: [],
      assigned_user: [],
      assigned_user_group: [],
      created_by: [],
      end_date: null,
      media: null,
      recurrence: [],
      state: [],
      date: null,
      tab: null,
    },
    lookupTableFilters: {
      [FILTER_TYPE_CREATED_BY]: [],
      [FILTER_TYPE_MODIFIED_BY]: [],
      [FILTER_TYPE_STATUS]: null,
      [FILTER_TYPE_DATE_CREATED_FROM]: null,
      [FILTER_TYPE_DATE_CREATED_TO]: null,
      [FILTER_TYPE_DATE_UPDATED_FROM]: null,
      [FILTER_TYPE_DATE_UPDATED_TO]: null,
    },
    myJobsFilters: {
      assignedByMe: true,
      assignedToMe: true,
      site: 0,
      preset: 'active',
      jobStates: [],
      assignees: [],
      creators: [],
      workflows: [],
      locusesAndGroups: [],
    },
    myJobsSorting: '',
    mnaFilters: { ...PROFILE_MNA_FILTERS },
    jobsDataViewerFilters: createMyJobDataViewFilters(),
    isSignatureSaving: false,
    isProfileFetching: false,
  })

function authentificate(state) {
  const _state = state.toJS()

  if (ProfileHelper.isAuth()) {
    const data = decodeJWT(ProfileHelper.getToken())
    _state.isAuth = true
    _state.jwtData = data
    _state.roleLevel = RoleHelper.getRoleLevel(data.roles)
  }

  return fromJS(_state)
}

const profile = handleActions(
  {
    [FETCH_PROFILE_SUCCESS]: (state, { payload }) => {
      const {
        licensee,
        site,
        mnaFilters,
        myJobsFilters,
        jobsDataViewerFilters,
        applications,
        myJobsSorting,
      } = payload
      // eslint-disable-next-line no-param-reassign
      payload.applications = List(applications)

      return state
        .set('licenseeId', licensee ? licensee.id : 0)
        .set('licenseeName', licensee ? licensee.name : '')
        .set('siteId', site ? site.id : 0)
        .set('mnaFilters', fromJS(mnaFilters))
        .set('myJobsFilters', fromJS(myJobsFilters))
        .set('jobsDataViewerFilters', fromJS(jobsDataViewerFilters))
        .set('profile', Map(payload))
        .set('myJobsSorting', myJobsSorting)
    },
    [SET_JWT_DATA]: (state, action) => {
      const data = action.payload

      return state
        .set('isAuth', true)
        .set('jwtData', Map(data))
        .set('roleLevel', RoleHelper.getRoleLevel(data.roles))
    },
    [SET_MY_JOBS_SITE_FILTER]: (state, action) =>
      state.setIn(['myJobsFilters', 'site'], action.payload),
    [SET_MY_JOBS_STATUS_FILTER]: (state, action) =>
      state.setIn(['myJobsFilters', 'jobStates'], List(action.payload)),
    [UPDATE_PROFILE_LOGBOOK_FILTERS_SUCCESS]: (state, { payload }) =>
      state.setIn(['profile', 'logbookFilters'], payload),
    [UPDATE_PROFILE_SITE_SUCCESS]: (state, { payload }) => {
      const { myJobsFilters } = state.toJS()
      const newFilters = {
        ...myJobsFilters,
        ...payload,
      }

      return state.set('myJobsFilters', fromJS(newFilters))
    },
    [SAVE_MANAGEMENT_UI_FILTERS_SUCCESS]: (state, { payload }) =>
      state.setIn(['profile', 'jobsManagementFilters'], payload),
    [SAVE_LOOKUP_TABLES_FILTERS_SUCCESS]: (state, { payload }) =>
      state.setIn(['profile', 'lookupTableFilters'], payload),
    [UPDATE_USER_LAST_APPLICATION_URL_SUCCESS]: (state, { payload }) =>
      state.setIn(['profile', 'lastApplicationUrl'], payload),
    [UPDATE_DEEP_LINK]: (state, { payload }) =>
      state.setIn(['profile', 'deepLink'], payload),
    [SET_CURRENT_APP_NAME]: (state, action) =>
      state.set('currentAppName', action.payload),
    [SET_PROFILE_MNA_FILTERS]: (state, { payload }) => {
      for (const key in payload) {
        if (
          payload.hasOwnProperty(key) &&
          PROFILE_MNA_FILTERS.hasOwnProperty(key)
        ) {
          // eslint-disable-next-line no-param-reassign
          state = state.setIn(['mnaFilters', key], fromJS(payload[key]))
        }
      }

      return state
    },
    [SET_MY_JOBS_DATA_VIEWER_FILTERS]: (state, { payload }) => {
      const baseFilters = createMyJobDataViewFilters()

      for (const key in payload) {
        if (payload.hasOwnProperty(key) && baseFilters.hasOwnProperty(key)) {
          // eslint-disable-next-line no-param-reassign
          state = state.setIn(
            ['jobsDataViewerFilters', key],
            fromJS(payload[key]),
          )
        }
      }

      return state
    },
    [SIGNATURE_IS_SAVING]: (state, action) =>
      state.set('isSignatureSaving', Boolean(action.payload)),
    [PROFILE_IS_FETCHING]: (state, action) =>
      state.set('isProfileFetching', Boolean(action.payload)),
    [SET_SITE]: (state, { payload }) =>
      state.setIn(['profile', 'site'], payload),
    [RESET_STORE]: () => {
      ProfileHelper.removeToken()

      return initialState()
    },
  },
  authentificate(initialState()),
)

export default profile
